
import Component from "vue-class-component";
import { Prop, Vue } from "vue-property-decorator";
import Icon from "@/components/icon/Icon.vue";

@Component({
  components: { Icon }
})
export default class Dropdown extends Vue {
  @Prop({ default: false }) readonly contain!: boolean;
}
